export function checkForNaN(a: number): number {
  return isNaN(a) ? 0 : a;
}
